import {btnEventCodeConst} from '../../conf';

/**
 * 拓扑插件-数据默认值定义
 */
export default {
  // 默认缩放比例
  ratio: 0.1,
  // 默认缩放实际大小
  realZoom: 1,
  // 默认画布最大放大、缩小倍数
  minZoom: 0.1,
  maxZoom: 3,

  formParam: {
    min: 0,
    max: 99999999,
    pointMin: -99999999,
    formMini: 'mini',
    minLabelWidth: '70px'
  },

  // 节点文本
  position: {
    top: 'top',
    left: 'left',
    center: 'center',
    right: 'right',
    bottom: 'bottom'
  },

  // 定义默认颜色选择器预置颜色
  predefineColors: [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    'rgba(255, 69, 0, 0.68)',
    'rgb(255, 120, 0)',
    'hsv(51, 100, 98)',
    'hsva(120, 40, 94, 0.5)',
    'hsl(181, 100%, 37%)',
    'hsla(209, 100%, 56%, 0.73)',
    '#c7158577'
  ],

  // 定义画布快捷键
  shortcuts: [
    { name: '撤销', eventCode: btnEventCodeConst.undoOperate, key: ['ctrl+z', 'command+z'], label: 'Ctrl + Z' },
    { name: '恢复', eventCode: btnEventCodeConst.redoOperate, key: ['ctrl+y', 'command+y'], label: 'Ctrl + Y' },
    // { name: '', eventCode: 'clearLog', key: 'mod+shift+l', label: 'Ctrl + Shift + L' },
    // { name: '', eventCode: 'history', key: 'mod+shift+h', label: 'Ctrl + Shift + H' },
    { name: '复制', eventCode: btnEventCodeConst.copyShape, key: ['ctrl+c', 'command+c'], label: 'Ctrl + C' },
    // { name: '粘贴', eventCode: 'paste', key: 'mod+v', label: 'Ctrl + V' },
    { name: '删除', eventCode: btnEventCodeConst.deleteShape, key: ['del', 'backspace'], label: 'Delete' },
    { name: '清空画布', eventCode: btnEventCodeConst.clearCanvasGraph, key: ['ctrl+shift+del', 'command+shift+del'], label: 'Ctrl + Shift + Del' },
    { name: '放大', eventCode: btnEventCodeConst.canvasZoomIn, key: ['ctrl+=', 'ctrl+plus', 'command+=', 'command+plus'], label: 'Ctrl + +' },
    { name: '缩小', eventCode: btnEventCodeConst.canvasZoomOut, key: ['ctrl+-', 'command+-'], label: 'Ctrl + -' },
    { name: '适应屏幕', eventCode: btnEventCodeConst.canvasFitView, key: ['ctrl+1', 'command+1'], label: 'Ctrl + 1' },
    { name: '实际大小', eventCode: btnEventCodeConst.canvasActualSize, key: ['ctrl+0', 'command+0'], label: 'Ctrl + 0' },
    { name: '全选', eventCode: btnEventCodeConst.selectAllGraph, key: ['ctrl+a', 'command+a'], label: 'Ctrl + A' },
    { name: '上移', eventCode: btnEventCodeConst.moveGraphUp, key: 'up', label: 'up' },
    { name: '下移', eventCode: btnEventCodeConst.moveGraphDown, key: 'down', label: 'down' },
    { name: '左移', eventCode: btnEventCodeConst.moveGraphLeft, key: 'left', label: 'left' },
    { name: '右移', eventCode: btnEventCodeConst.moveGraphRight, key: 'right', label: 'right' }
  ]
};
